export default {
  namespaced: true,
  billing_finance: {
    title: "Finanças",
    region: "Região",
    month: "Mês",
    year: "Ano",
    state: "Estado",
    rems: "REMS",
    security_company: "Empresa de Segurança",
    job_description: "Descrição do Cargo",
    number_of_services: "Número de Serviços",
    service_days: "Dias de Serviço",
    hours: "Horas",
    cost_per_shift: "Custo por Turno",
    type_of_guard: "Tipo de Guarda",
    work_schedule: "Jornada de Trabalho",
    save_successfully: "Salvo com sucesso",
    delete_many: "Excluir registros",
    delete: "Excluir registros",
    delete_question: "Tem certeza de que deseja excluir os registros filtrados?",
    delete_description: " registros serão excluídos.",
  }
}